var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1035 10.6345C19.3475 10.6345 10.6348 19.3472 10.6348 30.1033C10.6348 40.8593 19.3475 49.572 30.1035 49.572C40.8596 49.572 49.5723 40.8593 49.5723 30.1033C49.5723 19.3472 40.8596 10.6345 30.1035 10.6345ZM8.94727 30.1033C8.94727 18.4152 18.4155 8.94702 30.1035 8.94702C41.7916 8.94702 51.2598 18.4152 51.2598 30.1033C51.2598 41.7913 41.7916 51.2595 30.1035 51.2595C18.4155 51.2595 8.94727 41.7913 8.94727 30.1033Z",
    fill: "#ECFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9469 20.6751C34.279 21.002 34.2832 21.5362 33.9563 21.8683L26.1978 29.7495C26.0324 29.9176 26.0324 30.1352 26.1978 30.3032L33.9563 38.1844C34.2832 38.5165 34.279 39.0507 33.9469 39.3777C33.6148 39.7046 33.0806 39.7004 32.7537 39.3683L24.9952 31.4871C24.1832 30.6622 24.1832 29.3905 24.9952 28.5657L32.7537 20.6844C33.0806 20.3524 33.6148 20.3482 33.9469 20.6751Z",
    fill: "#ECFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.67eedf988ca1ba86ea27810c9a67aca7.svg";
export { ForwardRef as ReactComponent };